export default {"src":"/_next/static/image/public/images/flags/flag_674.919c84944439cd4da18035be112d8527.svg","height":16,"width":24};